var _metadata, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWizardBody(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 30 45",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#180b30",
    d: "M12 21h1M18 21h2M11 22h1M10 23h1M10 24h1M10 25h1M18 25h1M10 26h2M17 26h2M11 27h1M17 27h1M11 28h1M17 28h1M11 29h1M11 30h1M18 30h1M11 31h1M18 31h1M11 32h1M17 32h1M11 33h1M17 33h1M11 34h1M17 34h1M11 35h1M17 35h1M11 36h1M17 36h1M11 37h1M17 37h1M11 38h1M17 38h1M11 39h1M17 39h1M11 40h1M17 40h1M11 41h1M17 41h1M11 42h7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7a54a5",
    d: "M18 22h2M11 23h1M17 23h1M12 24h1M14 24h3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.29411764705882354)",
    d: "M13 23h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#613d8a",
    d: "M18 23h2M11 24h1M13 24h1M19 24h1M12 25h5M13 26h1M12 27h4M12 28h3M12 30h4M13 31h2M13 32h2M13 33h2M13 34h2M12 38h1M16 38h1M12 39h1M16 39h1M12 41h1M16 41h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3c2363",
    d: "M17 24h2M11 25h1M17 25h1M12 26h1M14 26h3M16 27h1M15 28h2M16 30h2M12 31h1M15 31h3M12 32h1M15 32h2M12 33h1M15 33h2M12 34h1M15 34h2M12 35h5M12 36h5M12 37h5M13 38h3M13 39h3M13 41h3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#dca465",
    d: "M12 29h1M15 29h2M12 40h1M16 40h1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffe498",
    d: "M13 29h2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cd975a",
    d: "M17 29h1M13 40h3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizardBody);
export default __webpack_public_path__ + "static/media/wizard-Body.96d5d6f87266c41e01cda11cdd1d45ea.svg";
export { ForwardRef as ReactComponent };